class DynamicWaterMaterialProperty {
    constructor(options) {
        this._definitionChanged = new Cesium.Event();
        this._color = undefined;
        this.color = options.color;
        this.duration = options.duration || 1000; //周期时间
        this._time = (new Date()).getTime();
    };

    get isConstant() {
        return false;
    }

    get definitionChanged() {
        return this._definitionChanged;
    }

    getType(time) {

        return "Water"
        // return Cesium.Material.DynamicWaterMaterialType;
    }

    getValue(time, result) {
        if (!Cesium.defined(result)) {
            result = {};
        }

        result.specularMap="";
        result.normalMap="data/img/textures/waterNormals.jpg";
        result.frequency=10000.0;
        result.animationSpeed=0.1;
        result.amplitude=1.0;
       
        return result
    }

    equals(other) {
        return (this === other ||
            (other instanceof DynamicWaterMaterialProperty &&
                Cesium.Property.equals(this._color, other._color))

        )
    }
}

Object.defineProperties(DynamicWaterMaterialProperty.prototype, {
    color: Cesium.createPropertyDescriptor('color')
})

export default DynamicWaterMaterialProperty